import React, { useState } from "react"
import DeleteModal from "../../../components/Common/DeleteModal"
import { usePagination } from "../../../hooks/usePagination"
import ResultHandler from "../../../components/ResultHandler"
import PaginationHandler from "../../../components/PaginationHandler"
import TableHeaderHandler from "../../../components/TableHeaderHandler"
import { useTranslation } from "react-i18next"
import { useResponse } from "../../../hooks/useResponse"
import TableAction from "../../../components/TableAction"
import EmptyData from "../../../components/EmptyData"
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { PERMISSIONS } from "../../../api/permissions";
import { getPriceComponents, deletePriceComponent } from "../../../api/priceComponent"
import { useParams } from "react-router-dom"
import { formatCurrency } from "../../../utils/formatCurrency"



export default function PriceComponentsTable({hideTableAction, hideTableHeader}) {

  const { t } = useTranslation()

  const {
    response,
    loading,
    error,
    setPage,
    page,
    setPerPage,
    totalPages,
    setPayload,

  } = usePagination(getPriceComponents)


  //// delete 
  const [show, setShow] = useState(false)

  function onCloseClick() {
    setShow(false)
  }

  const [deletingPriceComponent, setDeletingPriceComponent] = useState(null)

  const { setData } = useResponse(deletePriceComponent, () => {
    setShow(false)
    setDeletingPriceComponent(null)
    setPayload({})
  })

  function onDeleteClick() {
    setData({ type: "add", data: deletingPriceComponent })
  }



  return (
    <>
      {!hideTableHeader && <TableHeaderHandler
        permission={PERMISSIONS.PRICE_COMPONENT_CREATE}
        setPage={setPage}
        setPerPage={setPerPage}
        addUrl="add-price-component"
      >
       
      </TableHeaderHandler>}
   
      <div className="table-rep-plugin">
        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <Thead className="table-light table-nowrap">
              <Tr>
                <Th>Name</Th>
                <Th>Type</Th>
                <Th>Amount</Th>
                <Th>Is Vat</Th>
                <Th>Periodically</Th>
                <Th>Period</Th>

                {!hideTableAction && <Th style={{ width: "15%" }} className="text-center">{t("tables.Action")}</Th>}
              </Tr>
            </Thead>

            {response.data && !loading && (
              <Tbody>
                {response.data.priceComponents.map(row => {
                  return (
                    <Tr key={row.id}>
                      <Td>{row.name}</Td>
                      <Td>{row.type}</Td>
                      <Td>{row.amount_type == 'percentage' ? row.amount + "%" : formatCurrency(row.amount)}</Td>
                      <Td>{row.isVat ? "Yes" : "No"}</Td>
                      <Td>{row.isPeriodically ? "Yes" : "No"}</Td>
                      <Td>{row.period ? row.period+" days" : "-"}</Td>

                      {!hideTableAction && <Td className="text-center">
                        <TableAction
                          hasEdit={true}
                          hasDelete={true}
                          editPermission={PERMISSIONS.PRICE_COMPONENT_EDIT}
                          deletePermission={PERMISSIONS.PRICE_COMPONENT_DELETE}
                          type="price-component"
                          id={row.id}
                          setShow={setShow}
                          setDeleteIntitiy={setDeletingPriceComponent}
                        />
                      </Td>}
                    </Tr>
                  )
                })}
              </Tbody>
            )}
          </Table>

          {!loading &&
            <EmptyData empty={response.data && response.data.priceComponents.length === 0} msg="No Price Components Found." />
          }
          <DeleteModal
            show={show}
            onDeleteClick={onDeleteClick}
            onCloseClick={onCloseClick}
          />


          {response.data && !loading && (
            <PaginationHandler
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          )}


          <ResultHandler error={error} loading={loading} />

        </div>
      </div>
    </>
  )
}
